import React from 'react';
import { connect } from 'react-redux';
import {
  reduxForm,
  getFormSyncErrors,
} from 'redux-form';
import { withRouter } from 'react-router';

import validate from 'containers/SelfSignUp/validate';
import { setModal } from 'containers/RootModal/actions';

import {
  INVALID_EMAIL,
  INVALID_PASSWORD,
} from 'containers/RootModal/constants';

import { StyledForm, Row } from './styledComponents';
import { Field } from "redux-form";
import { sendEmailConfirmation } from '../actions'
import InputField  from "components/InputField"

const AccountForm = ({
  initialValues,
  handleSubmit,
  resendEmailConfirmation,
  syncErrors,
  openInvalidPasswordModal,
  openInvalidEmailModal,
  submitForm,
}) => {

  return (
    <StyledForm enableReinitialize={true}>

      {[
        ['First Name'.toUpperCase(), 'first_name',{}],
        ['Last Name'.toUpperCase(), 'last_name',{}],
        ['Company'.toUpperCase(), 'company',{}],
        [
          'Login Email (' + (initialValues.unconfirmed_email ? 'unconfirmed' : 'confirmed') + ')',
          initialValues.unconfirmed_email ? 'unconfirmed_email' : 'email',
          {
            customActionBtn: initialValues.unconfirmed_email ? resendEmailConfirmation : false,
            updateBtnText: 'Update Email',
            editBtnText: initialValues.unconfirmed_email ? "RESEND" : "change email".toUpperCase(),
            inPlace: true,
            inPlaceOnSubmit:  (data) =>  {
              if(!!syncErrors.email) {
                openInvalidEmailModal({ ...syncErrors.email})
              } else {
                handleSubmit(data)
              }
            }
          }
        ],
        [
          'Password'.toUpperCase(),
          'password',
          {
            type: 'password',
            inPlaceOnSubmit: (data) => {
              if(!!syncErrors.password) {
                openInvalidPasswordModal({ ...syncErrors.password })
              } else {
                handleSubmit(data)
              }
            }
          }

        ]
      ].map((field) =>  (
          <Row key={field[1]}>
            <Field
              label={field[0]}
              name={field[1]}
              component={InputField}
              inPlace={true}
              inPlaceOnSubmit={handleSubmit}
              {...field[2]}
            />
          </Row>
      ))}
    </StyledForm>
  );
}


const mapStateToProps = (state) => ({
    syncErrors: getFormSyncErrors('AccountForm')(state),
});

const mapDispatchToProps = (dispatch, ownProps) => ({
  resendEmailConfirmation: () => { dispatch(sendEmailConfirmation) },
  openInvalidPasswordModal: (modalProps) =>
    dispatch(setModal({ modalType: INVALID_PASSWORD, modalProps })),

  openInvalidEmailModal: () =>
    dispatch(setModal({ modalType: INVALID_EMAIL })),

})

export default reduxForm({
  form: 'AccountForm',
  validate,
})(connect(mapStateToProps, mapDispatchToProps)(withRouter(AccountForm)));



// WEBPACK FOOTER //
// ./src/containers/AccountPage/Forms/AccountForm.jsx